import { createGlobalStyle } from 'styled-components';

// FONTS
import InterLight from '../fonts/inter/inter-light.woff2';
import InterRegular from '../fonts/inter/inter-regular.woff2';
import InterBold from '../fonts/inter/inter-bold.woff2';
import InterExtraBold from '../fonts/inter/inter-extrabold.woff2';
import Amrinnatica from '../fonts/amrinnatica/amrinnatica-regular.woff2';

const GlobalStyle = createGlobalStyle`

  /* MAIN FONT */
  @font-face {
    font-family: 'Inter';
    src: local('Inter Light'), local('Inter-Light'), url(${InterLight}) format('woff2');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Inter';
    src: local('Inter Regular'), local('Inter-Regular'), url(${InterRegular}) format('woff2');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Inter';
    src: local('Inter Bold'), local('Inter-Bold'), url(${InterBold}) format('woff2');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'Inter';
    src: local('Inter Extra Bold'), local('Inter-ExtraBold'), url(${InterExtraBold}) format('woff2');
    font-weight: 800;
    font-style: normal;
  }

  /* CURSIVE FONT */
  @font-face {
    font-family: 'Amrinnatica';
    src: local('Amrinnatica Regular'), local('Amrinnatica-Regular'), url(${Amrinnatica}) format('woff2');
    font-weight: normal;
    font-style: normal;
  }
`;

export default GlobalStyle;